// extracted by mini-css-extract-plugin
export default {"textBlock":"Soglashenie_textBlock__ngIn3","article":"Soglashenie_article__UcLx-","list":"Soglashenie_list__JQ1Pt","listItem":"Soglashenie_listItem__9zTSR"};